module.exports = __webpack_public_path__ + "static/img/heroimage_wallet_large.f777c58.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/heroimage_wallet_large.png
// module id = 368
// module chunks = 1